import { type ReactElement, cloneElement, type JSX } from 'react';
import Box from '@mui/material/Box';
import { BodyS } from '../../../../typography';
import { Caption } from '../../../../typography';
import { useTheme } from '../../../../theme';
import { IconButton } from '../../iconButton';
import { Link } from '../../link';
import { useIntl } from '@doxyme/locale';
import { Icon, type IconProps } from '@doxyme/icons';

export type RichProps = {
  icon?: JSX.Element;
  title?: string;
  body?: string | JSX.Element;
  actionText?: string | JSX.Element;
  className?: string;
  onClick?: () => void;
  onClose?: () => void;
};

export const TooltipRich = ({
  icon,
  title,
  body,
  actionText,
  className,
  onClick,
  onClose,
}: RichProps): JSX.Element => {
  const theme = useTheme('dark');
  const { formatMessage } = useIntl();

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        padding: 1,
      }}
    >
      {Boolean(icon) &&
        cloneElement(icon as ReactElement<IconProps>, {
          css: {
            flexShrink: 0,
            width: 20,
            height: 20,
          },
        })}
      <Box
        sx={{
          display: 'flex',
          width: 191,
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 2,
        }}
      >
        {(Boolean(title) || Boolean(body)) && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 2,
              alignSelf: 'stretch',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: 1,
                flex: '1 0 0',
                alignSelf: 'stretch',
              }}
            >
              {Boolean(title) && (
                <BodyS fontWeight='medium' color={theme.text.generic.primary}>
                  {title}
                </BodyS>
              )}
              {Boolean(body) && (
                <Caption color={theme.text.generic.secondary}>{body}</Caption>
              )}
            </Box>

            {Boolean(onClose) && (
              <IconButton
                themeName='dark'
                size='xSmall'
                type='subtle'
                aria-label={formatMessage({ id: 'close' })}
                onClick={() => onClose?.()}
                icon={<Icon.Close size='xsmall' />}
              />
            )}
          </Box>
        )}

        {Boolean(actionText) && (
          <Link size='small' onClick={onClick} themeName='dark'>
            {actionText}
          </Link>
        )}
      </Box>
    </Box>
  );
};
